import * as React from 'react'
import Link from 'next/link'
import { useQueryParam } from '../../hooks/useQueryParam'
import { SitemapSectionItem } from '../../pages/site-map'

type Props = {
  title: string
  items: SitemapSectionItem[]
}
export const SitemapSection: React.FC<Props> = ({ title, items }) => {
  const query = useQueryParam()
  return (
    <div className="mb-8">
      <h2 style={{ fontWeight: 700 }}>{title}</h2>
      <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
        {items.map((item, index) => (
          <li key={item.title} style={{ paddingTop: index === 0 ? 0 : 20 }}>
            <Link href={item.path} as={{ pathname: item.path, query }}>
              <a className="text-lg">{item.title}</a>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
